import type { StockStatusEnum } from "../Stock.types";
import { stockStatusVariants } from "../Stock.utils";

export default function StockIndicator({
  status,
}: {
  status: StockStatusEnum;
}) {
  const { indicator: indicatorSlot } = stockStatusVariants({ status });
  return <output className={indicatorSlot()} />;
}
